var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.53 18.47C19.6037 18.5386 19.6628 18.6214 19.7038 18.7134C19.7447 18.8054 19.7668 18.9047 19.7686 19.0054C19.7703 19.1061 19.7518 19.2062 19.7141 19.2996C19.6764 19.393 19.6202 19.4778 19.549 19.549C19.4778 19.6202 19.393 19.6764 19.2996 19.7141C19.2062 19.7518 19.1061 19.7703 19.0054 19.7686C18.9047 19.7668 18.8054 19.7447 18.7134 19.7038C18.6214 19.6628 18.5386 19.6037 18.47 19.53L9.99997 11.0612L1.52997 19.53C1.38779 19.6625 1.19975 19.7346 1.00545 19.7311C0.811145 19.7277 0.62576 19.649 0.488347 19.5116C0.350934 19.3742 0.272222 19.1888 0.268794 18.9945C0.265365 18.8002 0.337488 18.6121 0.469968 18.47L8.93872 9.99997L0.469968 1.52997C0.337488 1.38779 0.265365 1.19975 0.268794 1.00545C0.272222 0.811145 0.350934 0.62576 0.488347 0.488347C0.62576 0.350934 0.811145 0.272222 1.00545 0.268794C1.19975 0.265365 1.38779 0.337488 1.52997 0.469968L9.99997 8.93872L18.47 0.469968C18.6121 0.337488 18.8002 0.265365 18.9945 0.268794C19.1888 0.272222 19.3742 0.350934 19.5116 0.488347C19.649 0.62576 19.7277 0.811145 19.7311 1.00545C19.7346 1.19975 19.6625 1.38779 19.53 1.52997L11.0612 9.99997L19.53 18.47Z",
    fill: "#F1EFE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.7d35acdfb6d3feed954926c9596ccb28.svg";
export { ForwardRef as ReactComponent };